import axiosInstance from './axiosInstance'
import { ApiResponse, Job, JobComment, PagedResponse } from '../types'

export const jobApi = {
  getFeed: (page = 0, size = 20, search = '') =>
    axiosInstance.get<ApiResponse<PagedResponse<Job>>>(
      `/jobs/feed?page=${page}&size=${size}${search ? `&search=${encodeURIComponent(search)}` : ''}`
    ),

  getById: (id: number) =>
    axiosInstance.get<ApiResponse<Job>>(`/jobs/${id}`),

  create: (data: {
    title: string
    description: string
    location?: string
    jobType?: string
    experienceMin?: number
    experienceMax?: number
    referralFeePaise?: number
    skills?: string[]
  }) => axiosInstance.post<ApiResponse<Job>>('/jobs', data),

  update: (id: number, data: Partial<{ title: string; description: string; skills: string[] }>) =>
    axiosInstance.put<ApiResponse<Job>>(`/jobs/${id}`, data),

  delete: (id: number) => axiosInstance.delete<ApiResponse<void>>(`/jobs/${id}`),

  getMyPosts: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<Job>>>(`/jobs/my-posts?page=${page}&size=${size}`),

  toggleLike: (id: number) =>
    axiosInstance.post<ApiResponse<{ liked: boolean; likesCount: number }>>(`/jobs/${id}/like`),

  getComments: (id: number, page = 0, size = 50) =>
    axiosInstance.get<ApiResponse<PagedResponse<JobComment>>>(`/jobs/${id}/comments?page=${page}&size=${size}`),

  addComment: (id: number, content: string) =>
    axiosInstance.post<ApiResponse<JobComment>>(`/jobs/${id}/comments`, { content }),

  deleteComment: (jobId: number, commentId: number) =>
    axiosInstance.delete<ApiResponse<void>>(`/jobs/${jobId}/comments/${commentId}`),

  getAttachmentPresignUrl: (jobId: number, filename: string, contentType: string) =>
    axiosInstance.post<ApiResponse<{ uploadUrl: string; s3Key: string }>>(
      `/jobs/${jobId}/attachments/presign`, { filename, contentType }
    ),
}
